import { Observable } from 'rxjs';
import { CacheService } from './cache.service';
import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { DIMBO_CONSTANT } from './../utils/constant';
import { AppConfig } from '../app.config';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  domain: string;
  istokenreceived: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(
    private httpService: HttpService,
    private apiconfig :AppConfig,
    private cacheService: CacheService
    ) {

      var apipath='';
        if(this.apiconfig.mpsaFlag==='N'){
          apipath = location.protocol + '//' + this.apiconfig.apiUrl;
        }

      this.domain = apipath+this.apiconfig.apiPath;
     }

  // Method to call a API for token authentication
  public authenticateToken(token: string): Observable<any> {
  //  console.log('Token from common service: ', token)

   // let domain = this.apiconfig.apiPath;
    const finalUrl = this.domain + DIMBO_CONSTANT.AUTHENTICATE_TOKEN;
    //console.log('finalUrl for token auth: ', finalUrl);
    let result: Observable<any>;
    result = this.httpService.getCallForToken(finalUrl, token);
    /* result.subscribe(response=> {
      console.log(123);
      console.log('response from subscription: ', response);
    }) */
    //console.log('response from getCallForToken: ', result);
    return result;
  }

  // Method to call a API for validating a token
  public validateToken(token: string) {
 //   let domain = this.apiconfig.apiPath;
      const finalUrl = this.domain+ DIMBO_CONSTANT.VALIDATE_TOKEN;
     // console.log('URL for token authentication: ', finalUrl);
      return this.httpService.getCallForToken(finalUrl, token);
  }

  // Method to call a API for getting DMBR contract ID
  public getDimboContract() {
    //let domain = this.apiconfig.apiPath;

    let params: any = {
      sourceApplication : this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_SOURCE_APPLICATION)
    }

    const queryParams = this.httpService.prepareQueryParams(params);
    let vin =this.cacheService.getItem(DIMBO_CONSTANT.CACHE_JWT_VIN);
    let finalURL=this.domain+'/'+vin+'/active-contract'+queryParams;
   // console.log('getDimboContract Final URL: ', finalURL);
    return this.httpService.getWithObserve(finalURL); 
  }

}
